/**
 * @generated SignedSource<<9512a908d2c68feef71e3f586fd6a5a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainExpireSelectorSetPriorityMutation$variables = {
  expireAt?: string | null;
  id: string;
};
export type WorkspaceTodoEditMainExpireSelectorSetPriorityMutation$data = {
  readonly todoWorkspace: {
    readonly updateExpireAt: {
      readonly expireAtDate: {
        readonly isoString: string;
      } | null;
      readonly id: string;
      readonly updatedAtDate: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainExpireSelector_Todo">;
    };
  };
};
export type WorkspaceTodoEditMainExpireSelectorSetPriorityMutation$rawResponse = {
  readonly todoWorkspace: {
    readonly updateExpireAt: {
      readonly expireAtDate: {
        readonly isoString: string;
      } | null;
      readonly id: string;
      readonly updatedAtDate: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceTodoEditMainExpireSelectorSetPriorityMutation = {
  rawResponse: WorkspaceTodoEditMainExpireSelectorSetPriorityMutation$rawResponse;
  response: WorkspaceTodoEditMainExpireSelectorSetPriorityMutation$data;
  variables: WorkspaceTodoEditMainExpireSelectorSetPriorityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expireAt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "newExpireAt",
    "variableName": "expireAt"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "UnzonedDate",
  "kind": "LinkedField",
  "name": "expireAtDate",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditMainExpireSelectorSetPriorityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateExpireAt",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainExpireSelector_Todo"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceTodoEditMainExpireSelectorSetPriorityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateExpireAt",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b01a9057fb1e4b23daef757f7f3c6762",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditMainExpireSelectorSetPriorityMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditMainExpireSelectorSetPriorityMutation(\n  $id: ID!\n  $expireAt: String\n) {\n  todoWorkspace(id: $id) {\n    updateExpireAt(newExpireAt: $expireAt) {\n      id\n      expireAtDate {\n        isoString\n      }\n      updatedAtDate {\n        ...FormattedDate\n        isoString\n      }\n      ...WorkspaceTodoEditMainExpireSelector_Todo\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainExpireSelector_Todo on TodoWorkspace {\n  id\n  updatedBy {\n    id\n    name\n  }\n  expireAtDate {\n    isoString\n  }\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "2f9795afaf1be622b801c0a4691e9bfc";

export default node;
